import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import { ToolbarItem, Vessel } from '../../vessels.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbar } from '@angular/material/toolbar';
import { LookupServiceSpa } from 'src/app/generated/services/lookups/lookupSpa';

@Component({
  selector: 'app-loading-time-toolbar',
  templateUrl: './loading-time-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialAutoCompleteComponent,
    MaterialDateRangeComponent,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatToolbar,
  ],
})
export class LoadingTimeToolbarComponent implements OnInit {
  @Output()
    itemsSelected: EventEmitter<ToolbarItem> = new EventEmitter<ToolbarItem>();
  title = new EventEmitter<string>();

  dateRange!: DateRange;
  _type!: string;
  allSofItems: string[][] = [];
  filterSofItems: string[][] = [];
  selectableSofItems: string[][] = [];
  extraSofEntry: string[] = [];
  extraSofEntry2: string[] = [];
  toolbarItem!: ToolbarItem;
  typeList: string[] = ['Loading', 'Discharge'];

  set type(value: string) {
    this._type = value;
    this.filterSOFItems();
  }

  constructor(private _lookupServiceSpa: LookupServiceSpa) {}

  ngOnInit(): void {
    this._lookupServiceSpa.getLookupItems({categoryName: 'voyage_sof_all'}).then((item) => {
      this.allSofItems = item.items.flatMap(item => [item.values]);
    });
    if (!this.dateRange) {
      this.dateRange = {
        startDate: moment(new Date()).subtract(365, 'days').toDate(),
        endDate: new Date(),
      };
    }
  }

  filterSOFItems() {
    if (this._type?.toLowerCase() === 'loading') {
      this.filterSofItems = this.allSofItems.filter((s) => s[0][0] === 'L');
    } else {
      this.filterSofItems = this.allSofItems.filter((s) => s[0][0] === 'D');
    }
    this.extraSofEntry = this.filterSofItems[0];
    this.extraSofEntry2 = this.filterSofItems[1];
  }

  onSubmit() {
    this.toolbarItem = {
      dateRange: this.dateRange,
      type: this._type,
      firstSOF: this.extraSofEntry[0],
      secondeSOF: this.extraSofEntry2[0],
    };
    if (this.itemsSelected) {
      this.itemsSelected.emit(this.toolbarItem);
    }
  }

  lookupItemListFormatter(item: [string, string, string]) {
    return item[1];
  }

  vesselFormatter(vessel: Vessel) {
    return vessel.name!.name;
  }
  typeFormatter(value: string){
    return value ?? '';
  }
}
